
export default async function fetchData(userData){
    try {
        const response = await fetch('https://askme-anything.net/api', {
            method:'POST',
            headers:{
            'Content-type': 'application/json'
            },
            body: JSON.stringify({'input':userData}),
        })
        const data = await response.text()
        return data
    }
    catch(error){
        console.error("Error fetching data from OpenAI")
    }

}

